import {FormLayoutProps} from "peggirkit/dist/components/Form/Layout/FormLayout";
import {defaultColumnSizing} from "peggirkit/dist/components/Form/Layout/LayoutSection/FormLayoutSection";
import React from "react";

export const defaultFormLayoutProps: Omit<FormLayoutProps, "children"> = {
    type: "stacked",
    sectionColumnSizing: {
        ...defaultColumnSizing,
        horizontal: {
            ...defaultColumnSizing.horizontal,
            gapClassname: "gap-12",
            containerCols: 9,
            titleColSpan: 2,
            contentColSpan: 7,
        },
    },
    breakpoints: {xl: {type: "horizontal"}},
};

export const slimCardFormLayoutProps: Omit<FormLayoutProps, "children"> = {
    type: "stacked",
    sectionColumnSizing: {
        ...defaultColumnSizing,
        stacked: {
            gapClassname: "gap-4",
            titleColSpan: 1,
            contentColSpan: 1,
            containerCols: 1,
        },
        horizontal: {
            ...defaultColumnSizing.horizontal,
            // gapClassname: "gap-12",
            containerCols: 3,
            titleColSpan: 1,
            contentColSpan: 2,
        },
    },
    sectionSpacing: {
        spacingClassname: "space-y-5",
        paddingBottomClassname: "pb-6",
    },
    breakpoints: {xl: {type: "horizontal"}},
};

export const defaultFormGridClassname = "w-full grid grid-cols-1 md:grid-cols-2 gap-x-5 gap-y-8";

export const FormGridFiller = () => (
    <div className={"hidden md:block"}></div>
);